
//mobile menu slider
document.addEventListener('DOMContentLoaded', function () {

  subscribe(PUB_SUB_EVENTS.cartUpdate, async function (e) {
    if (e.cartData) {
      const elementWithDataAttr = document.querySelector('.product__bundles--item');
      const freeGiftVariantId = elementWithDataAttr.getAttribute('data-rendered-product-id');

      const isChecked = document.querySelector('.product__bundles--list .checked');

      let cartData = await fetch("/cart.js").then((response) => response.json());
      const originalTotalPrice = cartData.original_total_price; // before discounts
      const freeGiftRemoved = localStorage.getItem('freeGiftRemoved');
      // const totalPrice = cartData.total_price; // after discounts
      if (isChecked && freeGiftRemoved !== 'true') {
        if (originalTotalPrice > 100 && !cartData.items.some((item) => item.variant_id === freeGiftVariantId)) {
          await fetch(`/cart/add.js?id=${freeGiftVariantId}`).then((response) => response.json());
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
        }
      } else {
        await fetch(`/cart/change.js?id=${cartData.items.find((item) => item.variant_id === freeGiftVariantId).key}&quantity=0`).then((response) => response.json());
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
        localStorage.setItem('freeGiftRemoved', 'true');
      }
    }
  });

    var swiper = new Swiper(".ctm_mobile_menu_slider", {
      slidesPerView: 2,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2,
        },
        575: {
          slidesPerView: 2,
        },
        414: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 2,
        },
      },
    });

  //Tab js
  // home page product redirect to perticuler collection
  const { hash } = window.location;
  const cleanHashtag = hash.slice(1);

  if (hash) {
    $("ul.tabs li").each(function (index, element) {
      const Tabs = $(element).attr("tab");
      const tab_id = $(element).attr("data-tab");

      if (Tabs == cleanHashtag) {
        $(this).addClass("current");
        $("#" + tab_id).addClass("current");
        setTimeout(() => {
          $(this).trigger("click");
        }, "2000");
      } else {
        $(this).removeClass("current");
        $("#" + tab_id).removeClass("current");
      }
    });
  }

  $(".collection_grid_tab_list ul.tabs li").click(function () {
    // Ignore anchor tabs - they handle their own navigation
    if ($(this).attr("data-anchor-tab") === "true" || $(this).hasClass("anchor-tab-link")) {
      return;
    }

    const { hash } = window.location;
    if (hash) {
      history.pushState(null, null, `/collections/all`);
    }
    var tab_id = $(this).attr("data-tab");

    history.pushState(null, null, `/collections/${$(this).attr("handle")}`);

    const fetchAndReplaceContent = (
      url = window.location.href,
      elementId = "ProductGridContainer"
    ) => {
      const element = document.getElementById(elementId);

      if (element) {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.onload = function () {
          if (xhr.status === 200) {
            const parser = new DOMParser();
            const responseDoc = parser.parseFromString(
              xhr.responseText,
              "text/html"
            );

            const newContent = responseDoc.querySelector(`#${elementId}`);
            if (newContent) {
              element.innerHTML = newContent.innerHTML;
            }
          }
        };
        xhr.send();
      }
    };
    fetchAndReplaceContent();
  });
  $("ul.tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  //footer menu js
  $(".footer-block__headings").click(function () {
    var targetFooterBlock = $(this).closest(".footer-block");
    var targetDetailsContent = targetFooterBlock.find(
      "ul.footer-block__details-content"
    );

    $(".footer-block").not(targetFooterBlock).removeClass("show");
    $("ul.footer-block__details-content")
      .not(targetDetailsContent)
      .removeClass("show");

    targetFooterBlock.toggleClass("show");
    targetDetailsContent.toggleClass("show");
  });

  // PDP Accordion

  $(".ctm_mobile_ans").hide();
  // $("#pdp-accordion > li:first-child").addClass("ctm_active").find(".ctm_mobile_ans").slideDown();
  $(".accordion-list > li, .accordon_item_v2_pdp").click(function (event) {
    var isPDPAcordian = $(this).parent().parent().attr('class');
    if (isPDPAcordian == 'ctm_pdp_accordion ') {
      if (!$(event.target).hasClass('accordion_inner')) {
        return;
      }
      if ($(this).hasClass("ctm_active")) {
        $(this).removeClass("ctm_active").find(".ctm_mobile_ans").slideUp();
      } else {
        $(".accordion-list > li.ctm_active .ctm_mobile_ans").slideUp();
        $(".accordion-list > li.ctm_active").removeClass("ctm_active");
        $(this).addClass("ctm_active").find(".ctm_mobile_ans").slideDown();
        // if (window.innerWidth > 768) {

        //   $('html, body').animate({
        //     scrollTop: 650
        //   }, 'smooth');
        // } else {

        //   $('html, body').animate({
        //     scrollTop: 1300
        //   }, 'smooth');
        // }
      }
    }
    return false;
  });

  // Other PDP Accordion

  $(".accordion-item-content").hide();
  $(".accordion-item > li .accordion_inner").click(function (event) {
    var accordionItem = $(this).closest(".accordion-item > li");
    if (accordionItem.hasClass("ctm_active")) {
      accordionItem.removeClass("ctm_active").find(".accordion-item-content").slideUp();
    } else {
      $(".accordion-item > li.ctm_active .accordion-item-content").slideUp();
      $(".accordion-item > li.ctm_active").removeClass("ctm_active");
      accordionItem.addClass("ctm_active").find(".accordion-item-content").slideDown();
    }
    return false;
  });

  var swiper = new Swiper(".review_slider", {
    slidesPerView: 1.1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".pdp-next",
      prevEl: ".pdp-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    breakpoints: {
      575: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 2.5,
      },
      1199: {
        slidesPerView: 3,
      },
    },
  });

  var swiper = new Swiper(".timeless_slider", {
    slidesPerView: 1.1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".pdp-next",
      prevEl: ".pdp-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    breakpoints: {
      575: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 2.5,
      },
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1199: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
    },
  });

  // fancy box video POPup
  $(".fancybox").fancybox({
    buttons: ["close"],
    hash: false,
    fullScreen: true,
    touch: true,
    infobar: false,
    autoPlay: true,
    animationEffect: true,
    arrows: false,
    iframe: {
      preload: false,
    },
    video: {
      controls: 0,
      showinfo: 0,
    },
  });

  // fancy box video Auto Play for Iphone
  //$(".fancybox-video").find('video').play
  $(".fancybox-video").find("video").attr("autoplay", "autoplay");
  var vid = document.getElementsByClassName("fancybox-video");
  function playVid() {
    vid.play();
  }
  var vids = $("video");
  $.each(vids, function () {
    this.controls = false;
  });

  /*Country code */
  setTimeout(function () {
    $.getJSON("http://ipinfo.io?token=b02da93fe981b7", function (e) {
      var country = e.country;
      if (country != "US") {
        $('.ctm_list3').css('display', 'none');
      }
    });
  }, 500);

  // img-text-mobile slider

    var swiper = new Swiper('.img-text-mobile-slider', {
      slidesPerView: '1',
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
      //  sticky  Swatch change
  const colorSpans = document.querySelectorAll('span[data-value-handle]');
    colorSpans.forEach(span => {
      span.addEventListener('click', () => {
        const handle = span.getAttribute('data-value-handle');
        const input = document.querySelector(`input[type="radio"][data-value-handle="${handle}"]`);
        if (input) {
          input.click();
        } else {
        }
        colorSpans.forEach(span => {
          span.classList.remove('active_sticky_shade');
        });

        // Add 'active' class to the clicked span
        span.classList.add('active_sticky_shade');
      });

      new Swiper('.ctm-swiper-container', {
      loop: false,
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
      },
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      breakpoints: {
          640: {
              slidesPerView: 1,
              spaceBetween: 25,
          },
          768: {
            slidesPerView: 1.2,
            spaceBetween: 25,
          },
          1024: {
              slidesPerView: 1.5,
              spaceBetween: 25,
          },
          1440: {
              slidesPerView: 2.3,
              spaceBetween: 25,
          },
      }
  });
    });

    // checkbox div start

      async function delay(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
      }

      async function insertHtmlContent() {
          if ($('.ctm_all_main').length > 0) {
              await delay(10000);

              var htmlContent = `
              <div style="padding: 0;">
                  <ul style="list-style-type: none; padding: 0; margin: 0;">
                      <li style="display: flex; align-items: center; margin-bottom: 5px;">
                          <span style="display: flex;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="20px" height="20px" fill="currentColor" role="presentation" style="width: 100%; height: 100%; color: green;" class="r-1f1hq4b"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path></svg></span>
                          <span style="margin-left: 5px; font-size: 18px; display: flex; gap: 5px;">Save <span class="disc_ausb" style="display: block;"></span> on every order</span>
                      </li>
                      <li style="display: flex; align-items: center; margin-bottom: 5px;">
                          <span style="display: flex;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="20px" height="20px" fill="currentColor" role="presentation" style="width: 100%; height: 100%; color: green;" class="r-1f1hq4b"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path></svg></span>
                          <span style="margin-left: 5px; font-size: 18px;">Cancel anytime with no fees</span>
                      </li>
                      <li style="display: flex; align-items: center; margin-bottom: 16px;">
                          <span style="display: flex;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="20px" height="20px" fill="currentColor" role="presentation" style="width: 100%; height: 100%; color: green;" class="r-1f1hq4b"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path></svg></span>
                          <span style="margin-left: 5px; font-size: 18px;">Edit your subscription anytime</span>
                      </li>
                      <li style="display: flex; align-items: center;">
                          <span style="margin-left: 5px; font-size: 18px;">Select delivery frequency</span>
                      </li>
                  </ul>
              </div>
              `;
              $('.rc-selling-plans.rc_widget__option__plans').prepend(htmlContent);
          }
      }

      insertHtmlContent();
      async function delay(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
      }

      // Select the target span element
      async function observeDiscountChanges() {
          await delay(1000); // Introduce a 10-second delay

          var targetSpan = document.querySelector('.rtx-subscription .savings');
          if (targetSpan) {

              // Function to update the anchor tag content
              async function updateAnchor() {
                  var discountContent = targetSpan.textContent;
                  var anchorTag = document.querySelector('.disc_ausb');
                  if (anchorTag) {
                      anchorTag.textContent = discountContent;
                  }
              }

              // Create an observer instance linked to the callback function
              var observer = new MutationObserver(async function(mutations) {
                  for (const mutation of mutations) {
                      if (mutation.type === 'childList') {
                          await updateAnchor();
                      }
                  }
              });

              // Start observing the target node for configured mutations
              observer.observe(targetSpan, { childList: true, subtree: true });

              // Call updateAnchor initially in case the content is already loaded
              await updateAnchor();

          } else {
              console.error('Target span element not found.');
          }
      }

      // Call the async function
      observeDiscountChanges();

    // checkbox div End

    // badges show on first image

    (async function () {
      if (document.querySelector('.ctm_all_main_pdp')) {

          function checkBadgeVisibility() {
              // Get the currently active slide's image
              const activeImage = document.querySelector('.product__column-sticky .slick-current img');

              if (activeImage) {
                  // Check if the active image's alt text contains 'visible_badge'
                  const badgeVisible = activeImage.alt.includes('visible_badge');

                  // Show or hide the badge list based on alt text
                  const badgeList = document.querySelector('.ctm_pdp_badge_logo');
                  if (badgeList) {
                      badgeList.style.display = badgeVisible ? 'block' : 'none';
                  }
              }
          }

          function delay(ms) {
              return new Promise(resolve => setTimeout(resolve, ms));
          }

          // Check badge visibility on page load after a delay
          await delay(1000);
          checkBadgeVisibility();

          // Mutation observer to watch for changes in the class attribute
          const observer = new MutationObserver(() => {
              checkBadgeVisibility();
          });

          // Observe the entire sticky column for class changes
          const stickyColumn = document.querySelector('.product__column-sticky');
          if (stickyColumn) {
              observer.observe(stickyColumn, { attributes: true, subtree: true });
          }

          // Check badge visibility when the slide changes
          document.querySelector('.product__column-sticky').addEventListener('afterChange', () => {
              checkBadgeVisibility();
          });

          // Check badge visibility when the variant changes
          const variantSelectors = document.querySelectorAll('.product__variants select, .product__variants input[type="radio"]');
          variantSelectors.forEach(selector => {
              selector.addEventListener('change', async () => {
                  // Wait for the variant change to take effect
                  await delay(1000);
                  checkBadgeVisibility();
              });
          });
      }
    })();

// modal
// Get the modal
var modelswatch = document.getElementById("myModal");

// Get the button that opens the modal
var btnswatch = document.getElementById("openModalBtnswatch");

// Get the <span> element that closes the modal
var spanswatch = document.getElementsByClassName("close-btn-sticky-atc")[0];
var cartDrawer = document.getElementById("cart-icon-bubble");

if (modelswatch) {
  modelswatch.style.display = "none";
}

if (btnswatch) {
  btnswatch.onclick = function () {
    let isVariant = document.querySelectorAll('.switch_list_grp')
    if (isVariant.length && modelswatch != null) {
      if (modelswatch) {
        modelswatch.style.display = "block";
      }
      document.querySelectorAll(".main-sticky-atc").forEach(function (element) {
        element.style.display = "none";
      });
    } else {
      document.querySelector('.product-form__submit').click();
    }
  }
}

if (spanswatch) {
  // When the user clicks on <span> (x), close the modelswatch
  spanswatch.onclick = function () {
    modelswatch.style.display = "none";
    document.querySelectorAll(".main-sticky-atc").forEach(function (element) {
      element.style.display = "block";
    });
  }
}
if (cartDrawer) {
  // When the user clicks on <span> (x), close the modelswatch
  cartDrawer.onclick = function () {
    modelswatch.style.display = "none";
    document.querySelectorAll(".main-sticky-atc").forEach(function (element) {
      element.style.display = "block";
    });
  }
}
// When the user clicks anywhere outside of the modelswatch, close it
window.onclick = function (event) {
    if (event.target == modelswatch) {
      modelswatch.style.display = "none";
    }
}

function refreshCart() {
  const cartDrawer = document.getElementById('CartDrawer');

  if (cartDrawer) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', window.location.href);
    xhr.onload = () => {
      if (xhr.status === 200) {
        const parser = new DOMParser();
        const responseDoc = parser.parseFromString(xhr.responseText, 'text/html');
        const newContent = responseDoc.querySelector('#CartDrawer');
        if (newContent) {
          cartDrawer.innerHTML = newContent.innerHTML;
        }
      }
    };
    xhr.send();
  }
}

  function addItemToCart(line) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        'id': line,
        'quantity': 1,
      },
      dataType: 'json',
        success: function () {
  refreshCart();
      },
        error: function () {
      }
    });
  }

$(document).on('click','.related-atc-btn',function(){
  var line = $(this).data("product-id");
  addItemToCart(line);
});

// Js for the hide price on which pdp contain the subscribe widget
// Function to wait for elements to be available in the DOM
function waitForElements(selector) {
  return new Promise((resolve) => {
    function checkElements() {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        resolve(elements);
      } else {
        requestAnimationFrame(checkElements);
      }
    }
    checkElements();
  });
}
// Function to hide elements if the "rc-container-wrapper" class is present
async function hideElementsIfRcContainerWrapperExists() {
  const rcContainerSelector = '.rc-container-wrapper';
  const moneyPriceSelector = '.ctm_all_main .price__container';

  const rcContainerElements = await waitForElements(rcContainerSelector);
  if (rcContainerElements.length > 0) {
    const moneyPriceElements = await waitForElements(moneyPriceSelector);
    moneyPriceElements.forEach(function(element) {
      element.style.display = 'none';
    });
  }
}
// Initial check on page load
hideElementsIfRcContainerWrapperExists();
// Function to handle variant change event
function handleVariantChange() {
  // Delay to ensure variant change is fully processed
  setTimeout(hideElementsIfRcContainerWrapperExists, 500);
}
// Observe changes in the variant selector
function observeVariantChanges() {
  const variantSelectors = document.querySelectorAll('form[action*="/cart/add"] select, form[action*="/cart/add"] input[type="radio"]');

  if (variantSelectors.length > 0) {
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', handleVariantChange);
    });
  }
}
// Wait for the variant selectors and set up the event listeners
waitForElements('form[action*="/cart/add"] select, form[action*="/cart/add"] input[type="radio"]').then(observeVariantChanges);
// Optional: Observe changes in Shopify sections
const observer = new MutationObserver(hideElementsIfRcContainerWrapperExists);
observer.observe(document.body, { childList: true, subtree: true });
});

function scrollToMainProduct() {
  document.querySelector("#main_product").scrollIntoView({
    behavior: "smooth",
  });
}

// Trusted by the best section Number counter animation
let counted = false;
$(window).scroll(function () {
  const counterElem = $("#counter_number");
  if (
    !counterElem.length ||
    counted ||
    $(window).scrollTop() <= counterElem.offset().top - window.innerHeight
  )
    return;
  counted = true;
  $(".counter-value").each(function () {
    const element = $(this);
    const countTo = element.attr("data-count");
    $({ countNum: element.text() }).animate(
      { countNum: countTo },
      {
        duration: 1000,
        easing: "swing",
        step: function () {
          element.text(Math.floor(this.countNum));
        },
        complete: function () {
          element.text(this.countNum);
        },
      }
    );
  });
});

function initializeProductSwatch(productID) {
  var swatchItems = document.querySelectorAll(`#${productID} .col-swatch li`);
  swatchItems.forEach(function (swatchItem) {
    swatchItem.addEventListener("click", function () {
      var span = swatchItem.querySelector("span");
      var shponowBtn = document.querySelector(
        "#" + productID + " .shponow-btn"
      );

      if (shponowBtn) {
        var atcSpan = shponowBtn.querySelector("span.col-atc");
        var soldOutSpan = shponowBtn.querySelector("span.sold-out-message");
        if (span.classList.contains("variant_disabled")) {
          shponowBtn.classList.add("btn_disable");
          atcSpan.classList.add("hidden");
          soldOutSpan.classList.remove("hidden");
        } else {
          shponowBtn.classList.remove("btn_disable");
          atcSpan.classList.remove("hidden");
          soldOutSpan.classList.add("hidden");
        }
      }

      swatchItems.forEach(function (item) {
        item.classList.remove("selected_shade");
      });

      swatchItem.classList.add("selected_shade");
      var newImage = swatchItem.getAttribute("data-href");
      var swatchTitle = swatchItem.getAttribute("data-option-title");
      var selectOptions = document.querySelectorAll(
        'select[name^="id"] option'
      );

      selectOptions.forEach(function (option) {
        var optionTitle = option.getAttribute("data-option-size");
        option.removeAttribute("selected");

        if (swatchTitle === optionTitle) {
          option.setAttribute("selected", "selected");
        }
      });

      if (
        newImage !==
        "//cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_large.gif"
      ) {
        var prodImage = document.querySelector(
          "#" + productID + " .prod-image img"
        );
        prodImage.setAttribute("src", newImage);
        prodImage.setAttribute("srcset", newImage);
      }

      return false;
    });
  });
}

(function() {
  'use strict';

  // Function to check if a request is from Elevar (and should be blocked)
  function isElevarRequest(stackTrace, requestBody) {
    // Check stack trace for Elevar indicators
    const stackIndicators = [
      'elevar',
      'dl-app-embed-block',
      'getelevar',
      'ELEVAR',
      'gtm-suite'
    ];

    const hasElevarInStack = stackIndicators.some(indicator =>
      stackTrace.toLowerCase().includes(indicator.toLowerCase())
    );

    // Convert request body to string for analysis
    let requestData = '';
    if (requestBody) {
      try {
        if (typeof requestBody === 'string') {
          requestData = requestBody;
        } else if (requestBody instanceof FormData) {
          // Convert FormData to string representation
          const formEntries = Array.from(requestBody.entries());
          requestData = formEntries.map(([key, value]) => `${key}=${value}`).join('&');
        } else if (typeof requestBody === 'object') {
          requestData = JSON.stringify(requestBody);
        }
      } catch (e) {
        // If we can't parse the body, fail open
        return false;
      }
    }

    // Check if request contains Intelligems data (comprehensive list)
    const hasIntelligemsData = requestData.includes('igId') ||
                               requestData.includes('_axon_client_id') ||
                               requestData.includes('igTestGroups') ||
                               requestData.includes('igCampaigns') ||
                               requestData.includes('igOffers') ||
                               requestData.includes('igPreview') ||
                               requestData.includes('intelligems');

    // Check stack trace for Intelligems indicators
    const isFromIntelligems = stackTrace.includes('intelligems') ||
                              stackTrace.includes('ig_') ||
                              stackTrace.includes('axon');

    // If it has Intelligems indicators, it's NOT from Elevar (allow it)
    if (hasIntelligemsData || isFromIntelligems) {
      return false;
    }

    // If no Intelligems indicators and has Elevar indicators, block it
    if (hasElevarInStack) {
      console.log('🚫 Detected Elevar request - blocking');
      return true;
    }

    // Default: fail open (allow unknown requests)
    return false;
  }

  // Function to completely disable ELEVAR
  function disableElevar() {
    console.log('🚫 Completely disabling ELEVAR...');

    // 1. Block ELEVAR localStorage
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function(key, value) {
      if (key.includes('ELEVAR') || key.includes('_elev')) {
        console.log('🚫 BLOCKED ELEVAR localStorage:', key);
        return; // Don't allow ELEVAR to write to localStorage
      }
      return originalSetItem.apply(this, arguments);
    };

    // 2. Enhanced fetch interception with smart blocking
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      const options = args[1] || {};

      // Smart blocking for /cart/update requests
      if (typeof url === 'string' && url.includes('/cart/update')) {
        const stackTrace = new Error().stack || '';
        const requestBody = options.body;

        // Check if this is specifically an Elevar request (not Intelligems)
        if (isElevarRequest(stackTrace, requestBody)) {
          console.log('🚫 BLOCKED ELEVAR fetch request to:', url);

          // Return a fake successful response for Elevar
          return Promise.resolve(new Response('{"note":"blocked by elevar blocker"}', {
            status: 200,
            headers: { 'Content-Type': 'application/json' }
          }));
        }
      }

      // For /cart/add, always allow (don't block legitimate additions)
      return originalFetch.apply(this, args);
    };

    // 3. Enhanced XMLHttpRequest interception
    const OriginalXMLHttpRequest = window.XMLHttpRequest;
    window.XMLHttpRequest = function() {
      const xhr = new OriginalXMLHttpRequest();
      const originalOpen = xhr.open;
      const originalSend = xhr.send;

      let requestUrl = '';
      let requestMethod = '';

      xhr.open = function(method, url, ...args) {
        requestUrl = url;
        requestMethod = method;
        return originalOpen.apply(this, [method, url, ...args]);
      };

      xhr.send = function(data) {
        if (requestUrl.includes('/cart/update') && requestMethod.toUpperCase() === 'POST') {
          const stackTrace = new Error().stack || '';

          // Check if this is specifically an Elevar request (not Intelligems)
          if (isElevarRequest(stackTrace, data)) {
            console.log('🚫 BLOCKED ELEVAR XMLHttpRequest to:', requestUrl);

            // Simulate successful response for Elevar
            setTimeout(() => {
              Object.defineProperty(xhr, 'readyState', { value: 4, writable: false });
              Object.defineProperty(xhr, 'status', { value: 200, writable: false });
              Object.defineProperty(xhr, 'responseText', { value: '{"note":"blocked by elevar blocker"}', writable: false });

              if (xhr.onreadystatechange) xhr.onreadystatechange();
              if (xhr.onload) xhr.onload();
            }, 0);

            return;
          }
        }

        return originalSend.apply(this, arguments);
      };

      return xhr;
    };

    // Copy over static properties
    Object.setPrototypeOf(window.XMLHttpRequest.prototype, OriginalXMLHttpRequest.prototype);
    Object.setPrototypeOf(window.XMLHttpRequest, OriginalXMLHttpRequest);

    // 4. Disable ELEVAR scripts
    const elevarScripts = document.querySelectorAll('script[src*="elevar"], script[src*="getelevar"]');
    elevarScripts.forEach(script => {
      script.remove();
      console.log('🗑️ ELEVAR script removed:', script.src);
    });

    // 5. Disable ELEVAR DOM elements
    const elevarElements = document.querySelectorAll('[class*="elevar"], [id*="elevar"]');
    elevarElements.forEach(el => {
      el.style.display = 'none';
      el.disabled = true;
    });

    // 6. Clear existing ELEVAR localStorage
    clearElevarStorage();

    // 7. Prevent ELEVAR from reloading
    if (window.ELEVAR) window.ELEVAR = null;
    if (window.elevar) window.elevar = null;
    if (window.Elevar) window.Elevar = null;

    console.log('✅ ELEVAR completely disabled with smart network interception');
  }

  // Enhanced function to clear localStorage
  function clearElevarStorage() {
    const elevarKeys = Object.keys(localStorage).filter(key =>
      key.includes('ELEVAR') || key.includes('_elev') || key.includes('GTM_SUITE')
    );

    elevarKeys.forEach(key => {
      console.log('🗑️ Removing ELEVAR key:', key);
      localStorage.removeItem(key);
    });

    // Also prevent recreation
    localStorage.setItem('___ELEVAR_DISABLED', 'true');
  }

  // Execute deactivation immediately
  disableElevar();

  // Also execute when page is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableElevar);
  }

  // Execute periodically to prevent reactivation
  setInterval(() => {
    const elevarStorage = Object.keys(localStorage).filter(key =>
      key.includes('ELEVAR') && !key.includes('DISABLED')
    );

    if (elevarStorage.length > 0) {
      console.log('⚠️ ELEVAR tried to reactivate, blocking...');
      clearElevarStorage();
    }
  }, 2000);

  // Global functions for manual control
  window.forceDisableElevar = disableElevar;
  window.clearElevarStorage = clearElevarStorage;

  console.log('🛡️ ELEVAR BLOCKER ACTIVATED with smart network interception');
  console.log('💡 ELEVAR blocked, Intelligems and other apps allowed through');
})();
